import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbComponent } from './breadcrumb.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslocoModule } from '@jsverse/transloco';

@NgModule({
  declarations: [BreadcrumbComponent],
  imports: [CommonModule, FlexLayoutModule, TranslocoModule],
  exports: [BreadcrumbComponent],
})
export class BreadcrumbModule {}
